'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeSelectors = normalizeSelectors;
function normalizeSelectors(selectors) {
  var normalizedSelectors = {
    success: {},
    error: {}
  };

  if (selectors) {
    if (selectors.success) {
      normalizedSelectors.success = selectors.success;
    } else if (!selectors.error) {
      normalizedSelectors.success = selectors;
    } else {
      normalizedSelectors.success = {};
    }

    if (selectors.error) {
      normalizedSelectors.error = selectors.error;
    }
  }

  return normalizedSelectors;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-7.24/js/selectorUtils.js
// module id = 268
// module chunks = 0